module.exports = __webpack_public_path__ + "img/more-blog.fe9a391d.png";